export default function (
  obj: Object,
  callback: (val: any, key: String | string) => boolean
): Object {
  if ((obj instanceof Object) && (obj != null))
    return Object.fromEntries(Object.entries(obj).filter(([key, val]) => callback(val, key)));

  return obj;
};
